import { IReactiveValidator } from '../reactive-context';

export abstract class SeReactiveValidator implements IReactiveValidator {
    private _error: string;
    get error() {
        return this._error;
    }

    constructor(error: string) {
        this._error = error;
    }

    abstract validate(state: unknown): boolean;
}

export class RequiredValidator extends SeReactiveValidator {
    validate(state: unknown) {
        return state != null && state != '';
    }
}

export class RequiredHtmlValidator extends SeReactiveValidator {
    private readonly serializer = document.createElement('div');

    validate(state: unknown) : boolean{
        if (typeof state !== 'string') {
            return false;
        }

        this.serializer.innerHTML = state;

        return this.serializer.innerText.trim() !== '';
    }
}
